// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"transactions_loader_container__KGDjl","backdrop":"transactions_backdrop__21cuM","top_content":"transactions_top_content__37hTJ"};